import { Typography, Button } from '@libs/components';
import styled from 'styled-components';

export const Container = styled.div`
  padding: 0;
  background-color: transparent;
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  box-shadow: unset;
  margin: 3.6rem 0;
  ${({ theme }) => theme.media.tabletM`
      box-shadow:${theme.shadows.sm as unknown as TemplateStringsArray};
      padding:2.4rem;
      margin: 0 0 2.4rem;
      background-color: ${
        theme.colors.surface.default as unknown as TemplateStringsArray
      };
  `}
`;
export const Title = styled(Typography)`
  padding-left: 1.6rem;
  ${({ theme }) => theme.media.tabletM`
      padding-left:0;
  `}
`;
export const ListWrapper = styled.div`
  display: flex;
  flex-wrap: unset;
  gap: 1.2rem;
  margin-top: 2.4rem;
  overflow-x: scroll;
  padding-left: 1.6rem;
  &::-webkit-scrollbar {
    display: none;
  }
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  ${({ theme }) => theme.media.tabletM`
    overflow:unset;
    flex-wrap: wrap;
    padding-left: 0;
  `}
`;
export const ListContainer = styled.div`
  background: linear-gradient(126deg, #4f67ee 0%, #1a004e 100%);
  padding: 4rem 0.3rem 0.3rem;
  min-width: 18rem;
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  flex: 1 1 calc(25% - 1.2rem);
  cursor: pointer;
  ${({ theme }) => theme.media.tabletM`
        border-radius: ${
          theme.borderRadius.high as unknown as TemplateStringsArray
        };
        min-width:14.5rem;
        padding:0;
        background: ${
          theme.colors.surface
            .interactiveDefault as unknown as TemplateStringsArray
        };
  `}
`;
export const ListInsideWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  background-color: ${({ theme }) => theme.colors.surface.default};
  border-radius: ${({ theme }) => theme.borderRadius.highM};
  padding: 2.6rem 2rem 2rem;
  height: 100%;
  gap: 1.2rem;
  ${({ theme }) => theme.media.tabletM`
        padding:2rem;
          border-radius: ${
            theme.borderRadius.high as unknown as TemplateStringsArray
          };
        background-color: ${
          theme.colors.surface
            .interactiveDefault as unknown as TemplateStringsArray
        };
  `}
`;
export const ListIconWrapper = styled.div`
  position: absolute;
  top: -2.2rem;
  left: 1.5rem;
  width: 4.4rem;
  height: 4.4rem;
  border: 4px solid ${({ theme }) => theme.colors.surface.default};
  border-radius: ${({ theme }) => theme.borderRadius.highest};
  ${({ theme }) => theme.media.tabletM`
            top: unset;
            left: unset;
            position:relative;
            width:3.4rem;
            height:3.4rem;
            margin-bottom: 0.4rem;
            border: 0.4px solid transparent;
  `}
`;
export const DescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: auto;
`;
export const CustomImage = styled.img`
  width: 100%;
  object-fit: cover;
  background-color: ${({ theme }) => theme.colors.text.interactive};
  border-radius: ${({ theme }) => theme.borderRadius.highest};
`;
export const Footer = styled.div`
  padding: 1.2rem 1.6rem 0;
  ${({ theme }) => theme.media.tablet`
         padding: 2rem 0 0; 

  `}
`;
export const CustomButton = styled(Button)`
  background-color: transparent;
`;
